export const transformRedactedContent = (htmlContent, mode) => {
  if (!htmlContent) return htmlContent;
  
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlContent, 'text/html');
  const redactedElements = doc.querySelectorAll('.redacted-text');
  
  redactedElements.forEach(element => {
    const originalText = element.getAttribute('data-original');
    const redactionId = element.getAttribute('data-redaction-id');
    
    if (mode === 'question') {
      const input = doc.createElement('input');
      input.type = 'text';
      input.className = 'redacted-input';
      input.placeholder = '___';
      input.setAttribute('data-redaction-id', redactionId);
      input.setAttribute('data-original', originalText);
      element.parentNode.replaceChild(input, element);
    } else {
      element.textContent = originalText;
      element.style.backgroundColor = '#3e8ed0';
      element.style.color = 'white';
    }
  });
  
  return doc.body.innerHTML;
};

export const hasRedactedContent = (content) => {
  if (!content) return false;
  return content.includes('redacted-text') || content.includes('data-lexical-redacted');
};
